import { IonIcon, IonLabel } from '@ionic/react'
import { home } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { trpc } from '../../modules/trpc'

interface Props {
	onInteraction?: () => void
	onClick?: (optionValue: string) => void
	state: [string | null, React.Dispatch<React.SetStateAction<string | null>>]
}

type ObjectType = 'apartment' | 'rowhouse' | 'house' | 'cottage' | 'other'

const ObjectTypeSlide: React.FC<Props> = ({ onInteraction, onClick, state }) => {
	const object = useContext(ObjectContext)
	const utils = trpc.useContext()

	if (!object) return null

	const { t } = useTranslation('pages_onboarding')

	const objectTypeOptions = [
		{
			icon: home,
			label: t('objectTypeSlide.kerrostalo'),
			value: 'apartment',
		},
		{
			icon: home,
			label: t('objectTypeSlide.riviPariTalo'),
			value: 'rowhouse',
		},
		{
			icon: home,
			label: t('objectTypeSlide.omakotitalo'),
			value: 'house',
		},
		{
			icon: home,
			label: t('objectTypeSlide.mokki'),
			value: 'cottage',
		},
		{
			icon: home,
			label: t('objectTypeSlide.muuKohde'),
			value: 'other',
		},
	]

	const { mutate: updateObject } = trpc.objects.edit.useMutation({
		onSuccess: () => {
			onInteraction?.()
		},
	})

	const handleClick = async (optionValue: string) => {
		if (onClick) {
			onClick(optionValue)
			return
		}

		state[1](optionValue)

		updateObject({
			id: object.id,
			data: { type: optionValue as ObjectType },
		})

		utils.user.getObjects.invalidate()
	}

	const defaultStyle =
		'option border border-brand-primary-100-light dark:border-brand-primary-100-dark'

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>{t('objectTypeSlide.millainenKohde')}</h1>
			<div className='options-container'>
				{objectTypeOptions.map(option => (
					<div
						key={option.value}
						onClick={() => handleClick(option.value)}
						className={`${defaultStyle}${state[0] === option.value ? ' bg-brand-secondary-200-light dark:bg-surface-dark' : ' hover dark:bg-[#031f22] bg-[#f5f5f5]'}`}
					>
						<IonIcon
							className='text-brand-primary-100-light dark:text-brand-primary-100-dark'
							icon={option.icon}
						/>
						<IonLabel className='text-text-dark dark:text-white'>{option.label}</IonLabel>
					</div>
				))}
			</div>
		</>
	)
}

export default ObjectTypeSlide
